module.exports = __webpack_public_path__ + "img/logo_tzw2.ffda3439.png";